import { afterNextRender, DestroyRef, inject } from '@angular/core';
import { SnowplowService } from './snowplow';
import { makeEvent } from '../analytics/builder';
import { AnalyticsEventMap } from '../analytics/type';

const CONTENT_READ_DELAY_MS = 5000;

// Fires one `element_read` Snowplow event after the component has been on screen for 5s;
// leaving earlier cancels it. Call from the constructor. The event is built when it fires, so
// it can read inputs that aren't set yet at construction.
export function trackContentRead(event: () => AnalyticsEventMap['element_read']): void {
  const snowplow = inject(SnowplowService);
  const destroyRef = inject(DestroyRef);

  afterNextRender(() => {
    const timeout = setTimeout(() => {
      // track() drops events until the tracker is set up (finnetWeb's consent lookup can take
      // up to 6s) — wait for it.
      void snowplow.trackerReady().then(() => snowplow.track(makeEvent('element_read', event())));
    }, CONTENT_READ_DELAY_MS);
    destroyRef.onDestroy(() => clearTimeout(timeout));
  });
}
